'use client';

import { handle_GTM_64 } from '@gtm/64';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { useIntersectionObservers } from 'eco-design-micro/hooks/useIntersectionObservers';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import Arrow from '../../product-series/content/icons';
import { ItfDiscoverMoreData, ItfDiscoverMoreItem } from '../setting/type';
import './index.scss';

interface ItfAniArrItem {
    name: string;
    cls: string;
}

export default function Content({ id, data = {}, isEditStatus }: ContentServerProps) {
    const { theme, title, titleColor, desc, descColor, items = [] as ItfDiscoverMoreItem[] } = data as ItfDiscoverMoreData;
    const prefixCls = 'discover-more';

    const [enter, setEnter] = useState({
        title: isEditStatus,
        desc: isEditStatus,
        content: isEditStatus,
    });

    const arr: ItfAniArrItem[] = [
        { name: 'title', cls: `${prefixCls}-info-title` },
        { name: 'desc', cls: `${prefixCls}-info-desc` },
        { name: 'content', cls: `${prefixCls}-swiper-box` },
    ];

    const handle_GTM_Event = (item: ItfDiscoverMoreItem) => {
        const { url, text } = item;
        // 4. 其他
        handle_GTM_64({
            list_name: title,
            button_name: text,
            position: `Series_DiscoverMore_${id}`,
            __btn_id1: `editor-${prefixCls}-${id}`,
            __btn_id2: url,
            __btn_type: 'href',
        });
    };

    useIntersectionObservers(
        {
            selectors: [
                `.editor-${prefixCls}-${id} .${prefixCls}-info-title`,
                `.editor-${prefixCls}-${id} .${prefixCls}-info-desc`,
                `.editor-${prefixCls}-${id} .${prefixCls}-swiper-box`,
            ],
            onEnter: (e: Element) => {
                const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
                if (aim) {
                    setEnter((prev) => ({ ...prev, [aim.name]: true }));
                }
            },
            // onLeave: (e: Element) => {
            //     const aim: ItfAniArrItem | undefined = arr?.find((i: ItfAniArrItem) => i.cls === e.classList?.[0]);
            //     if (aim) {
            //         setEnter((prev) => ({ ...prev, [aim.name]: false }));
            //     }
            // },
        },
        [],
        isEditStatus,
    );

    return (
        <GloLayout className={`editor-${prefixCls} editor-${prefixCls}-${id} theme-${theme}`} id={id} data={data} floorName={prefixCls}>
            <div className={`${prefixCls}-info`}>
                {title && (
                    <div className={`${prefixCls}-info-title ${enter?.title ? 'enter' : ''}`} style={{ color: titleColor }} title={title}>
                        {title}
                    </div>
                )}
                {desc && (
                    <div className={`${prefixCls}-info-desc ${enter?.desc ? 'enter' : ''}`} style={{ color: descColor }} title={desc}>
                        {desc}
                    </div>
                )}
            </div>
            <div className={`${prefixCls}-swiper-box`}>
                <Swiper className={`${prefixCls}-swiper`} initialSlide={0} spaceBetween={12} slidesPerView={'auto'} modules={[Navigation]} navigation={true}>
                    {items.map((item: ItfDiscoverMoreItem, index: number) => {
                        const { name, text, url, pc, h5 } = item;
                        const itemClassesA = classNames({
                            [`${prefixCls}-swiper-item`]: true,
                            [`${prefixCls}-swiper-item-${index}`]: true,
                            ['enter']: enter?.content,
                        });
                        return (
                            <SwiperSlide
                                className={itemClassesA}
                                key={`${index}`}
                                style={{ transitionDelay: enter?.content ? `${(index + 1) * 0.15}s` : '0s' }}
                            >
                                {url && (
                                    <EcoLink
                                        className={`${prefixCls}-swiper-item-inner GtmModuleData-btn-href`}
                                        href={url}
                                        onClick={() => handle_GTM_Event(item)}
                                        title={text}
                                    >
                                        <div className={`${prefixCls}-swiper-item-img`}>
                                            <EcoImg pc={pc} h5={h5} aria-label={item.name} alt={item.name} />
                                        </div>
                                        <div className={`${prefixCls}-swiper-item-content`}>
                                            {name && (
                                                <div className={`${prefixCls}-swiper-item-content-name`} title={name}>
                                                    {name}
                                                </div>
                                            )}
                                            {text && (
                                                <p className={`${prefixCls}-swiper-item-content-text`}>
                                                    <span>{text}</span>
                                                    <Arrow />
                                                </p>
                                            )}
                                        </div>
                                    </EcoLink>
                                )}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </GloLayout>
    );
}
